import { images } from "../images";

export const ongoinData = [
  {
    id: 1,
    title: "SEMI-FINAL",
    date: "15 FEBRUARY, 2025",
    time: "08:00 PM",
    team01Img: images.teamLogo01.image,
    team01Alt: images.teamLogo01.alt,
    team02Img: images.teamLogo02.image,
    team02Alt: images.teamLogo02.alt,
    imgWidth1: "mumbai_logo",
    imgWidth2: "singams_logo",
  },
];

export const upcomingData = [
  {
    id: 1,
    match: "MATCH 03",
    date: "10 JANUARY, 2026",
    time: "08:00 PM",
    team01Img: images.teamTiger.image,
    team01Alt: images.teamTiger.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "tigers_logo",
    imgWidth2: "singams_logo",
    // vsImg: "vs_img5",
    containerClass: "logo_wrapper1",
    score1: "58/5",
    over1: "10 overs",
    score2: "102/8",
    over2: "10 overs",
    result: "Chennai Singams won by 44 runs",
  },
  {
    id: 2,
    match: "MATCH 10",
    date: "15 JANUARY, 2026",
    time: "08:00 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamFalcon.image,
    team02Alt: images.teamFalcon.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "falcon_logo",
    vsImg: "vs_img2",
    containerClass: "logo_wrapper3",
    score1: "118/2",
    over1: "10 overs",
    score2: "80/7",
    over2: "10 overs",
    result: "Chennai Singams won by 38 runs",
  },
  {
    id: 3,
    match: "MATCH 13",
    date: "17 JANUARY, 2026",
    time: "05:30 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamMumbai.image,
    team02Alt: images.teamMumbai.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "mumbai_logo",
    vsImg: "vs_img3",
    containerClass: "logo_wrapper4",
    score1: "95/10",
    over1: "10 overs",
    score2: "71/8",
    over2: "10 overs",
    result: "Chennai Singams won by 24 runs",
  },
  {
    id: 4,
    match: "MATCH 17",
    date: "19 JANUARY, 2026",
    time: "08:00 PM",
    team01Img: images.teamLions.image,
    team01Alt: images.teamLions.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "lions_logo",
    imgWidth2: "singams_logo",
    vsImg: "vs_img5",
    containerClass: "logo_wrapper6",
    score1: "72/4",
    over1: "10 overs",
    score2: "52/8",
    over2: "10 overs",
    result: "Ahmedabad Lions won by 20 runs",
  },
  {
    id: 5,
    match: "MATCH 18",
    date: "20 JANUARY, 2026",
    time: "08:00 PM",
    team01Img: images.teamDelhi.image,
    team01Alt: images.teamDelhi.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "delhi_logo",
    imgWidth2: "singams_logo",
    vsImg: "vs_img6",
    containerClass: "logo_wrapper5",
    score1: "88/6",
    over1: "8.3 overs",
    score2: "87/7",
    over2: "10 overs",
    result: "Delhi Superheros won by 4 wickets",
  },
  {
    id: 6,
    match: "MATCH 21",
    date: "22 JANUARY, 2026",
    time: "08:00 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamStrikers.image,
    team02Alt: images.teamStrikers.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "strikers_logo",
    // vsImg: "vs_img",
    containerClass: "logo_wrapper1",
    score1: "57/6",
    over1: "10 overs",
    score2: "61/6",
    over2: "8.5 overs",
    result: "Bengaluru Strikers won by 4 wickets",
  },
  {
    id: 7,
    match: "MATCH 24",
    date: "24 JANUARY, 2026",
    time: "05:30 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamSrinagar.image,
    team02Alt: images.teamSrinagar.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "srinagar_logo",
    vsImg: "vs_img2",
    containerClass: "logo_wrapper3",
    score1: "50/6",
    over1: "5.5 overs",
    score2: "42/9",
    over2: "10 overs",
    result: "Chennai Singams won by 4 wickets",
  },
  {
    id: 8,
    match: "MATCH 27",
    date: "25 January, 2026",
    time: "08:00 PM",
    team01Img: images.teamStrikers.image,
    team01Alt: images.teamStrikers.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "strikers_logo",
    imgWidth2: "singams_logo",
    vsImg: "vs_img3",
    containerClass: "logo_wrapper4",
    score1: "80/7",
    over1: "10 overs",
    score2: "84/6",
    over2: "9.5 overs",
    result: "Chennai Singams won by 4 wickets",
  },
  {
    id: 9,
    match: "MATCH 33",
    date: "30 JANUARY, 2026",
    time: "05:30 PM",
    team01Img: images.teamDelhi.image,
    team01Alt: images.teamDelhi.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "delhi_logo",
    imgWidth2: "singams_logo",
    vsImg: "vs_img5",
    containerClass: "logo_wrapper6",
    score1: "57/10",
    over1: "9.2 overs",
    score2: "105/3",
    over2: "10 overs",
    result: "Chennai Singams won by 48 runs",
  },
  {
    id: 10,
    match: "MATCH 39",
    date: "02 FEBRUARY, 2026",
    time: "05:30 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamLions.image,
    team02Alt: images.teamLions.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "lions_logo",
    vsImg: "vs_img6",
    containerClass: "logo_wrapper5",
    score1: "90/5",
    over1: "10 overs",
    score2: "92/5",
    over2: "10 overs",
    result: "Ahmedabad Lions won by 2 runs",
  },
  {
    id: 11,
    match: "QUALIFIER 01",
    date: "03 FEBRUARY, 2026",
    time: "07:00 PM",
    team01Img: images.teamLions.image,
    team01Alt: images.teamLions.alt,
    team02Img: images.teamSingams.image,
    team02Alt: images.teamSingams.alt,
    imgWidth1: "lions_logo",
    imgWidth2: "singams_logo",
    vsImg: "vs_img5",
    containerClass: "logo_wrapper6",
    score1: "57/10",
    over1: "9.4 overs",
    score2: "61/5",
    over2: "8 overs",
    result: "Chennai Singams won by 5 wickets",
  },
  {
    id: 12,
    match: "FINAL",
    date: "06 FEBRUARY, 2026",
    time: "07:00 PM",
    team01Img: images.teamSingams.image,
    team01Alt: images.teamSingams.alt,
    team02Img: images.teamTiger.image,
    team02Alt: images.teamTiger.alt,
    imgWidth1: "singams_logo",
    imgWidth2: "tigers_logo",
    vsImg: "vs_img6",
    containerClass: "logo_wrapper5",
    score1: "103/7",
    over1: "10 overs",
    score2: "74/9",
    over2: "10 overs",
    result: "Chennai Singams won by 29 runs",
  },
];
